export class PageErrorModel {
  code: number;
  message: string;
}
